import { useEffect } from "react";

/**
 * Injects a schema.org JSON-LD <script> into <head> while `data` is
 * non-null, removing it on unmount or when `data` becomes null. Callers
 * pass null when the underlying record doesn't exist yet (see
 * legalRegistrations.ts) — emitting empty/fake structured data to search
 * engines would be its own honesty problem, so nothing is injected until
 * there's something real to describe.
 */
export default function useStructuredData(data: Record<string, unknown> | null) {
  useEffect(() => {
    if (!data) return;

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [data]);
}
